import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import fpodb from '../../../db.json';
import { Accordion, SelectedFiltersComponent, Checkbox, Pagination } from './filter-components';

const safeString = (str) => {
    return encodeURIComponent(str);
}

const Legal = () => {

    let legal = document.querySelectorAll('.legal');

    const legalConstructor = (id) => {
        Vue.component('legal-template', {
            data: function() {
                return {
                    data: {
                        currentPage: 1, //current page #
                        totalPages: null, //total returns pages
                        totalResults: null, //total results
                        shownResults: null, //total shown items
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true,
                        filters: [],
                        products: [],
                        results: [],
                        emailDocs: [], //for emailing
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs,
                        savedDocsOnly: null, //is saved docs only checked?
                        isMobile: null,
                        nextActive: null,
                        prevActive: null,
                        // apiUrl: null, //for api call
                        urlParams: null, //for deeplinking in-browser
                        shareAll: false,
                        class: 'legal',
                        trackingType: 'document'
                        // store: store
                    }
                }
            },
            components: {
                'filter-accordion-template': Accordion,
                'selectedFilters': SelectedFiltersComponent,
                'checkbox-item': Checkbox,
                'pagination': Pagination
            },
            computed: {
                computedIsMobile: function() {
                    return store.state.isMobile;
                },
                saved: function() {
                    return store.state.favorites.legalDocumentId;
                },
                pageRange: function() {
                    if (this.data.totalResults > 10) {
                        if (this.data.currentPage == 1) {
                            return `1-${this.data.shownResults}`;
                        } else if (this.data.currentPage == this.data.totalPages ) {
                            return `${this.data.totalResults - this.data.shownResults + 1}-${this.data.totalResults}`;
                        } else {
                            return `${(this.data.shownResults * (this.data.currentPage - 1)) + 1}-${this.data.shownResults * this.data.currentPage}`;
                        }
                    } else {
                        return this.data.shownResults;
                    }
                },
                page: function() {
                    return this.data.currentPage;
                }
            },
            watch: {
                saved: function() {
                    this.data.savedDocs = this.saved;

                    // remove saved only filter if no saved items
                    if (this.saved.length == 0) {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf('savedDocuments');
                        if (index > -1) {
                            this.data.filters.splice(index,1);
                        }
                    }
                },
                computedIsMobile: function() {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;
                },
                "data.filters": function() {
                    this.getResults(); // handle api call
                    // this.updateHistory(); // handle history record
                    // this.data.currentPage = 1; //reset page to 1
                    this.data.emailDocs = [];
                    
                    // check for if brand is selected
                    let brands = this.data.filters.filter(el => {
                        return el.type == "brand";
                    }).map(el => {
                        return el.value;
                    });

                    // set savedDocsOnly value
                    let savedOnly = this.data.filters.find(item => {
                        return item.type == "savedDocuments";
                    })
                    this.data.savedDocsOnly = savedOnly ? savedOnly.value : null;

                },
                page: function() {
                    if (this.data.currentPage == 1) {
                        this.data.nextActive = true;
                        this.data.prevActive = false;
                    } else if (this.data.currentPage == this.data.totalPages) {
                        this.data.nextActive = false;
                        this.data.prevActive = true;
                    } else {
                        this.data.nextActive = true;
                        this.data.prevActive = true;
                    }

                    // this.getResults();
                    // this.updateHistory();
                },
                "data.totalResults": function() {
                    this.initPages();
                }
                
            },
            methods: {
                toggleFilters() {
                    // console.log("clicked");
                    if (this.data.isMobile) {
                        // console.log("is mobile");
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== this.data.class) {
                        return;
                    }

                    var type = type;
                    var value = safeString(e.currentTarget.value);
                    var label = e.currentTarget.parentNode.innerText;
                    var checked = e.currentTarget.checked;
                    this.data.currentPage = 1;
                    // console.log("type", type)
                    // console.log(e);
                    // console.log("value", safeString(e.target.value));
                    // console.log("checked",e.target.checked);

                    if (checked) {
                        if (type !== "savedDocuments") {
                            this.data.filters = [...this.data.filters, {"value": value, "type": type, "name": label}];
                        } else {
                            this.data.filters = [...this.data.filters, {"value": checked, "type": type, "name": label}];
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        // console.log("INDEX", index);
                        this.data.filters.splice(index,1);
                    }
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) {return; }
                    let index = this.data.filters.map((e) => {
                        return e.value
                    }).indexOf(value);
                    this.data.filters.splice(index,1);
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                    this.data.currentPage = 1; //reset page to 1
                },  
                
                getUrl() {
                    let savedParams = this.data.savedDocs.toString();

                    let certTypeParams = this.data.filters.filter(item => {
                        return item.type == "certType"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let langParams = this.data.filters.filter(item => {
                        return item.type == "lang"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let docTypeParams = this.data.filters.filter(item => {
                        return item.type == "docType"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let regionParams = this.data.filters.filter(item => {
                        return item.type == "region"
                    }).map(item => {
                        return item.value;
                    }).toString();

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return savedOnly.value;
                        } else {
                            return false;
                        }
                    }

                    let pageParams = this.data.currentPage;

                    this.data.urlParams = `?${certTypeParams !== "" ? "&certificationType=" + certTypeParams : ""}${langParams !== "" ? "&lang=" + langParams : ""}${regionParams !== "" ? "&region=" + regionParams : ""}${docTypeParams !== "" ? "&docType=" + docTypeParams : ""}&savedDocuments=${savedDocumentsTrueParams()}&page=${pageParams}`;

                },
                getResults(query) {
                    // let apiUrl = "api/documents?";
                    this.data.currentPage = query ? 1 : this.data.currentPage;
                    this.getUrl();
                    let baseUrl = window.legalAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/legal"; //from json-server

                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var certType = [];
                    var lang = [];
                    var region = [];
                    var docType = [];

                    this.data.filters.map((item) => {
                        switch(item.type) {
                            case "certType":
                                certType.push(item.value);
                                break;
                            case "lang":
                                lang.push(item.value);
                                break;
                            case "region":
                                region.push(item.value);
                                break;
                            case "docType":
                                docType.push(item.value);
                                break;
                            default:
                                return;
                        }
                    });

                    let certTypeStr = decodeURIComponent(certType.join('|'));
                    let langStr = decodeURIComponent(lang.join('|'));
                    let regionStr = decodeURIComponent(region.join('|'));
                    let docTypeStr = decodeURIComponent(docType.join('|'));

                    let axiosParams = {
                        q: query ? query : null,
                        saved: (this.data.savedDocs.join('|')) == "" ? null : this.data.savedDocs.join('|').charAt(0) == "," ? this.data.savedDocs.join('|').slice(1) : this.data.savedDocs.join('|'), //@TODO make this less insane. Send NULL if empty string. Remove leading comma if present.
                        certificationType: certTypeStr == "" ? null : certTypeStr,
                        language: langStr == "" ? null : langStr,
                        region: regionStr == "" ? null : regionStr,
                        docType: docTypeStr == "" ? null : docTypeStr,
                        savedDocuments: savedDocumentsTrueParams(),
                        page: this.data.currentPage,
                    }

                    // console.log(axiosParams);
                    axios.get(apiUrl, {
                            params: {
                                ...axiosParams
                            }
                        })
                        .then(function(response) {
                            // console.log(response);
                            self.data.results = response.data.results;  
                            self.data.totalResults = response.data.totalResults;
                            self.data.shownResults = response.data.results.length;
                            //console.log(response.data);
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                },
                changePage(dir) {
                    if (dir == "prev" && this.data.currentPage !== 1) {
                        this.data.currentPage--;
                    } else if (dir == "next" && this.data.currentPage !== this.data.totalPages) {
                        this.data.currentPage++;
                    } else {
                        return;
                    }
                    EventBus.$emit('scroll-to-top', this.data.class);
                    this.getResults();
                },
                updateEmailDocs(data) {
                    let item = this.data.emailDocs.find(item => {
                        return item.id == data.id;
                    });

                    if (!item) {
                        this.data.emailDocs = [...this.data.emailDocs, data];
                    } else {
                        this.data.emailDocs.splice(this.data.emailDocs.indexOf(item),1);
                    }
                },
                //update history record when filters change
                updateHistory() {
                    let url = `${window.location.pathname}${this.data.urlParams}`;
                    history.pushState("","",url);
                },
                // handle deep linking on history change
                deeplink() {
                    let params = window.location.search.substr(1).split("&").filter(item => {
                        return item != ""
                    });
                    // console.log(params);
                    // this.data.filters = []; //clear filters array first

                    var initFilters = [];
                    let page;

                    params.forEach(param => {
                        let type = param.slice(0, param.indexOf('='));
                        let content = param.slice(param.indexOf('=') + 1);
                        // console.log("TYPE",type);
                        // console.log("CONTENT", content);

                        let entry = {}
                        if (type == "page") {
                            // console.log("PAGE", parseInt(content));
                            // this.data.currentPage = parseInt(content);
                            page = parseInt(content);
                        } else if (type == "savedDocuments") {
                            if (content == "false" || content == false) {
                                return;
                            } else {
                                entry = {
                                    "type": type,
                                    "value": true,
                                    "name": this.data.savedDocsLabel
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            }
                        } else if (content.indexOf(',') > -1) {
                            let contentArray = content.split(',');
                            contentArray.forEach(item => {
                                entry = {
                                    "type": type,
                                    "value": item,
                                    "name": decodeURIComponent(item)
                                }

                                initFilters = [
                                    ...initFilters,
                                    entry
                                ]
                            });
                        } else {
                            entry = {
                                "type": type,
                                "value": content,
                                "name": decodeURIComponent(content)
                            }

                            initFilters = [
                                ...initFilters,
                                entry
                            ]
                        }

                        this.data.filters = initFilters;
                        // console.log(this.initFilters);

                    });

                    this.data.currentPage = page;

                },
                scrollToTop(el) {
                    if (el !== this.data.class) {return;}
                    let top = this.$el.querySelector('.legal__area-cards').getBoundingClientRect().top + window.scrollY - 100;
                    // console.log(top);
                    setTimeout(function() {
                        window.scrollTo({
                            top: top,
                            behavior: 'smooth'
                        });
                    }, 500);
                },
                initPages() {
                    // based on total result count, divide by 10 to get total pages needed
                    // math ceil to round up
                    // set active for prev/next based on current page
                    this.data.totalPages = Math.ceil(this.data.totalResults / 10);
                    this.data.prevActive = this.data.currentPage !== 1 ? true : false;
                    this.data.nextActive = this.data.currentPage !== this.data.totalPages ? true : false;
                },
                init() {
                    this.data.isMobile = store.state.isMobile;
                    this.data.savedDocs = store.state.favorites.legalDocumentId[0] == "" ? store.state.favorites.legalDocumentId.slice(1) : store.state.favorites.legalDocumentId;
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init show/hide filters if/is mobile
                    // listen for filter updates in children
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el ,value, type);
                    });
                    EventBus.$on('change-page-to', (el, num) => {
                        if (el !== this.data.class) {return;};
                        this.data.currentPage = num;
                        this.getResults();
                    });
                    EventBus.$on('email-docs', (data) => {
                        this.updateEmailDocs(data);
                    });
                    EventBus.$on('internal-search', (value, type) => {
                        if (type == "documentation") {
                            this.getResults(value);
                        }
                    });
                    EventBus.$on('scroll-to-top', (el) => {
                        this.scrollToTop(el);
                    });
                    // init results
                    this.data.results = window.initialLegalApiResults.results;
                    this.data.totalResults = window.initialLegalApiResults.totalResults;
                    this.data.shownResults = window.initialLegalApiResults.results.length;
                    // this.data.results = fpodb.legal.results;
                    // this.data.totalResults = fpodb.legal.totalResults;
                    // this.data.shownResults = fpodb.legal.results.length;


                    // hide filters if less then 10 initial results
                    this.data.filterAreaVisible = parseInt(this.data.totalResults) <= 10 ? false : true;

                    // enable "share all" if 5 of less results
                    this.data.shareAll = parseInt(this.data.totalResults) <= 5 ? true : false;
                    // window.onpopstate = () => {
                    //     this.deeplink();
                    // }
                }
            },
            mounted() {
                this.init();
                this.initPages();
                // for deeplinking
                if (window.location.search) {
                    this.$nextTick(() => {
                        this.deeplink();
                    });
                }
            }
        });

        
        // results list
        Vue.component('legal-results-list', {
            props: ['data'],
            data: function() {
                return {
                    type: "product"
                }
            },
            template: `
            <div class="legal__cards-content" :data="data">
                <legal-results-item v-for="(result, index) in data.results" :content="result" :isSelected="isSelected(result)" :key="result.id" :data="data"/>
            </div>
            `,
            methods: {
                isSelected(result){
                    return this.data.emailDocs.find(i => i.id == result.id) !== undefined;
                }
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('legal-results-item', {
            props: ['data', 'content', 'isSelected'],
            data: function() {
                return {
                    isChecked: this.isSelected,
                    isBookmarked: false,
                    id: null,
                    seeAll: null, //is "see all" feature enabled,
                    seeAllOpen: null,
                    seeAllLabel: null,//label
                    moreContent: null,
                }
            },
            computed: {
                saved: function() {
                    return store.state.favorites.legalDocumentId;
                },
                encodedUrl: function() {
                    return encodeURIComponent(this.content.url);
                },
                newTabLink: function() {
                    return this.content.url.replace('download=true', 'download=false');
                },
                tagMetaBody: function() {
                    return JSON.stringify({
                        "type": "legalDocument", 
                        "category": this.content.eyebrow, 
                        "label": this.content.name, 
                        "language": this.content.language
                    })
                }
            },
            watch: {
                saved: function() {
                    this.isBookmarked = this.saved.includes(this.id) ? true : false;
                },
                "data.emailDocs": function() {
                    if(this.data.emailDocs.length === 0){
                        this.isChecked = false;
                    }
                },
                "content": function() {
                    // update id when content changes
                    this.$nextTick(() => {
                        // console.log(this.$refs.bookmark.dataset.documentId);
                        this.id = this.$refs.bookmark.dataset.legalDocumentId;
                        this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                    })
                },
                "seeAll": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "seeAllOpen": function() {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                }
            },
            template: `
            <div class="doc-card doc-card--checkbox" :data="data" :class="{'hide-bookmark': (data.savedDocsOnly === true) && (isBookmarked === false)}" data-tag-trigger="click" :data-tag-meta='tagMetaBody'>
                <div class="doc-card__wrapper">
                    <div class="doc-card__row">
                        <div class="doc-card__area doc-card__area-checkbox">
                        <div class="checkbox">
                                <label class="checkbox__label">
                                    <input type="checkbox" class="checkbox__input" :value="content.id" v-on:change="emailDoc" v-model="isChecked" :checked="isChecked" data-tag-trigger="click" data-tag-meta='{"type": "legalDocument", "action": "Select"}'>
                                    <span class="checkbox__checkmark"></span>
                                </label>
                            </div>
                        </div>
                        
                        <div class="doc-card__area doc-card__area-info">
                            <div class="doc-card__area doc-card__area-left">
                                <span class="doc-card__eyebrow">
                                    {{content.eyebrow}}
                                </span>
                                <a :href="newTabLink" class="doc-card__title" target="_blank" data-tag-trigger="click" data-tag-meta='{"type": "legalDocument", "action": "Preview"}'>
                                    {{content.name}}
                                </a>
                                <span class="doc-card__subtitle">
                                    <span class="doc-card__subtitle-content" ref="seeAllContent">{{content.details}}</span> <span class="doc-card__subtitle-more" v-if="seeAll && seeAllOpen">\{{moreContent}}</span> <a href="#" v-on:click.prevent="toggleSeeAll" v-if="seeAll">\{{seeAllLabel}}</a> | {{content.language}}
                                </span> 
                            </div>
                            <div class="doc-card__area doc-card__area-right">
                                <a class="doc-card__icon doc-card__icon-download" :href="content.url" data-tag-trigger="click" data-tag-meta='{"type": "legalDocument", "action": "Download"}'></a>
                                <a class="doc-card__icon doc-card__icon-email" :href="'mailto:?subject=Badger%20Meter%20Document%20Links&body=' + content.name + ': ' + this.encodedUrl" data-tag-trigger="click" data-tag-meta='{"type": "legalDocument", "action": "Email"}'></a>
                                <a class="doc-card__icon doc-card__icon-bookmark" :data-legal-document-id="content.id" ref="bookmark" v-on:click="handleBookmark" :class="{active: isBookmarked}" data-tag-trigger="click" data-tag-meta='{"type": "legalDocument", "action": "Favorite"}'></a>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
            `,
            methods: {
                emailDoc() {
                    EventBus.$emit('email-docs', {"name": this.content.name, "url": this.content.url, "id": this.content.id});
                },
                handleBookmark() {
                    store.commit('updateFavorites', {
                        id: this.id,
                        type: "legalDocumentId",
                        action: this.isBookmarked ? "remove" : "add"
                    });
                    store.dispatch('checkFavorites');
                },
                toggleSeeAll() {
                    this.seeAllOpen = !this.seeAllOpen;
                },
                initSeeAll() {
                    if (this.$refs.seeAllContent) {
                        let details = this.$refs.seeAllContent.innerHTML.split(',');
                        this.seeAll = details.length > 3 ? true : false;

                        let truncatedDetails = details.slice(0,3).join();
                        let moreDetails = details.slice(3).join();

                        this.moreContent = moreDetails;
                        this.$refs.seeAllContent.innerHTML = `${truncatedDetails}${moreDetails == "" ? '' : ','}`;
                    }
                }
            },
            mounted() {
                this.id = this.$refs.bookmark.dataset.legalDocumentId;
                this.isBookmarked = this.saved.includes(`${this.id}`) ? true : false;
                // console.log("saved",this.saved);
                this.initSeeAll();
            }
        });

        Vue.component('email-docs', {
            props: ['data'],
            data: function() {
                return {
                    mailto: null,
                    // mailtoAll: null
                }
            },
            watch: {
                "data.emailDocs": function() {
                    let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                    this.data.emailDocs.forEach(item => {
                        mailto = `${mailto}${encodeURIComponent(item.name)}: ${encodeURIComponent(item.url)}%0D%0A`;
                    });
                    this.mailto = mailto;
                }
            },
            methods: {
                // shareAll() {
                //     let mailto = "mailto:?subject=Badger%20Meter%20Document%20Links&body=";
                //     this.data.results.forEach(item => {
                //         mailto = `${mailto}${item.name}: ${item.url}%0D%0A`;
                //     });
                //     this.mailtoAll = mailto;
                // }
            },
            mounted() {
                // if (parseInt(this.data.totalResults) <= 5) {
                //     this.shareAll();
                // }
            }
        });

        new Vue({
            el: `.legal-${id}`,
            store: store
        }).$mount(`.legal-${id}`, true);
    }

    if (legal.length > 0) {
        legal.forEach((item, index) => {
            item.classList.add(`legal-${index}`);
            legalConstructor(index);
        })
    }

    window.seeLessLabel = "see less";
    window.seeAllLabel = "see more";

}

export default Legal;
